@let reviewForm = form();
@let images = snapshots();
@let selectedLinks = reviewForm.controls.selectedImages.value;

@if ((images?.length ?? 0) > 0) {
  <app-pan-card header="Recent Walk-Ins">
    @if (selectedLinks.length > 0) {
      <app-pan-chip size="sm" color="info" [canRemove]="true" (remove)="clearSelection()">
        {{ selectedLinks.length }} selected
      </app-pan-chip>
    } @else if (reviewForm.controls.didNotReturn.value) {
      <span>&thinsp;(Did not return) </span>
    }

    <p class="mb-2 text-sm">Select photos that indicate the person might have returned or confirm that the "Person did not return"</p>

    <div class="overflow-y-auto max-h-[50vh]">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        @for (image of images; track image.id) {
          <div
            class="relative border rounded p-2 cursor-pointer hover:bg-gray-50 transition"
            [ngClass]="{ 'bg-blue-50 border-2 border-blue-600 ring-2 ring-blue-300': isSelected(image.link) }"
            [title]="walkInTimestampLabel(image.image_timestamp)"
            (click)="toggleSelection(image)"
          >
            <div class="text-xs text-gray-600 mb-1">{{ walkInTimestampLabel(image.image_timestamp) }}</div>
            <img draggable="false" [src]="image.link" class="w-full h-44 object-contain select-none" />
            @if (isSelected(image.link)) {
              <div class="absolute top-2 right-2 text-blue-600">
                <mat-icon>check_circle</mat-icon>
              </div>
            }
          </div>
        }
      </div>
    </div>

    @if (selectedLinks.length === 0) {
      <div [formGroup]="reviewForm" class="px-4 py-6 self-center">
        <input
          panCheckbox
          checked
          formControlName="didNotReturn"
          id="didNotReturn"
          type="checkbox"
          value=""
          data-testid="didNotReturn"
          (change)="clearSelection()"
        />
        <label class="ms-2 text-sm font-medium text-gray-900" for="didNotReturn"> Person did not return </label>
      </div>
    }
  </app-pan-card>
}
